import { render, staticRenderFns } from "./shuttleTable.vue?vue&type=template&id=141b4e6c&scoped=true"
import script from "./shuttleTable.vue?vue&type=script&lang=js"
export * from "./shuttleTable.vue?vue&type=script&lang=js"
import style0 from "./shuttleTable.vue?vue&type=style&index=0&id=141b4e6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141b4e6c",
  null
  
)

export default component.exports